import "/app/node_modules/core-js/modules/es.array.iterator.js";
import "/app/node_modules/core-js/modules/es.promise.js";
import "/app/node_modules/core-js/modules/es.object.assign.js";
import "/app/node_modules/core-js/modules/es.promise.finally.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.object.to-string.js";
import Vue from 'vue';
import App from './App.vue';
// 引入ColaPay前端初始化相关内容
import './core/gin-vue-admin';
// 引入封装的router
import router from '@/router/index';
import '@/permission';
import { store } from '@/store';
// 初始化同盾
import { initTongdun } from '@/utils/Tongdun';
initTongdun();
Vue.config.productionTip = false;
import { auth } from '@/directive/auth';
import { indi } from '@/utils/date';
import i18n from '@/i18n';
// 按钮权限指令
auth(Vue);
Vue.filter('dateFormat', function (val) {
  return indi(val);
});
export default new Vue({
  render: function render(h) {
    return h(App);
  },
  router: router,
  store: store,
  i18n: i18n
}).$mount('#app');